exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".item {\n  display: flex;\n  align-items: center;\n}\n.item .value {\n  max-width: 30%;\n  min-width: 4em;\n  text-align: center;\n}", ""]);

// exports
